import * as React from "react";

import { IconCancel } from "../icons/IconCancel";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonCancel: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonCancel.title;
    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconCancel fixedWidth />
        </MprcIconButton>
    );
};
